class SupportInnerVideoInstance {
  constructor(node) {
    this.block = node;

    this.selectors = {
      video: '.c-video',
      videoMarkersItem: '.c-support-inner-video__markers-item',
    };

    this.classNames = {
      videoMarkersItemActive: 'c-support-inner-video__markers-item--active',
    };

    this.bootstrap();
  }

  bootstrap() {
    const video = this.block.querySelector(this.selectors.video);

    const videoMarkersItems = this.block.querySelectorAll(
      this.selectors.videoMarkersItem,
    );

    videoMarkersItems.forEach(item => {
      item.addEventListener('click', () => {
        video.youTubePlayer.play();
        video.youTubePlayer.seekTo(item.dataset.startsAt || 0);

        videoMarkersItems.forEach(marker => {
          marker.classList.remove(this.classNames.videoMarkersItemActive);
        });

        item.classList.add(this.classNames.videoMarkersItemActive);
      });
    });
  }
}

export default class SupportInnerVideo {
  constructor() {
    this.selector = '.c-support-inner-video';
  }

  bootstrap() {
    const nodes = document.querySelectorAll(this.selector);

    nodes.forEach(node => new SupportInnerVideoInstance(node));
  }
}
